import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useIdleTimeout } from '../../hooks/useIdleTimeout';
import { queryClient } from '../../providers/QueryProvider';
import { SessionTimeoutWarningDialog } from './SessionTimeoutWarningDialog';

/**
 * Self-contained session timeout manager.
 * Isolates the per-second countdown re-renders from the rest of the app tree.
 */
export const SessionTimeoutManager: React.FC = () => {
  const { logout } = useAuth0();

  const handleSessionLogout = React.useCallback(() => {
    // PRX-87: the next person at an idle workstation never inherits this
    // user's cached lists (the recent-patients history among them).
    queryClient.clear();
    localStorage.removeItem('pharmacy-store');
    localStorage.removeItem('recentPharmacies');
    localStorage.removeItem('sidebarHidden');
    localStorage.removeItem('sidebarCollapsed');
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  const { showWarning, secondsRemaining, extendSession } = useIdleTimeout({
    onLogout: handleSessionLogout,
  });

  return (
    <SessionTimeoutWarningDialog
      open={showWarning}
      secondsRemaining={secondsRemaining}
      onExtendSession={extendSession}
      onLogout={handleSessionLogout}
    />
  );
};
